import { render, staticRenderFns } from "./SiteAttachments.vue?vue&type=template&id=2b5e4efe"
import script from "./SiteAttachments.vue?vue&type=script&lang=js"
export * from "./SiteAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports